import shoppingCart from '/asset/shopping-basket-01.svg';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { PurchaseItem } from '../interfaces';
import { useEffect, useState } from 'react';
import { fetchPurchaseCart } from '../store/purchaseSlice';

export default function CartBasketTop({
  isAtBottom,
}: {
  isAtBottom?: boolean;
}) {
  const purchaseData = useSelector(
    (state: RootState) => state.purchase.purchase
  );
  const [cart, setCart] = useState<PurchaseItem[]>([]);
  const auth_token = useSelector((state: RootState) => state.auth.token);
  const { routesPrefix } = useSelector((state: RootState) => state.setup);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    setCart(purchaseData?.purchases ?? []);
  }, [purchaseData]);

  useEffect(() => {
    dispatch(fetchPurchaseCart());
  }, [auth_token, dispatch]);

  useEffect(() => {
    if (cart) {
      const count = cart.reduce((total, item) => total + item.quantity, 0);
      setCartCount(count);
    } else {
      setCartCount(0);
    }
  }, [cart]);
  return (
    <div
      className={`
        pointer-events-none
        mr-2
        !py-0 !px-0
        ${isAtBottom ? 'bg-white' : 'bg-transparent'}
      `}
    >
      <div
        className="h-[30px] w-[30px] 
        relative cursor-pointer 
        pointer-events-auto pt-1"
        onClick={() => {
          navigate(`${routesPrefix}cart`);
        }}
      >
        <img
          src={shoppingCart}
          alt=""
          aria-hidden="true"
          className="w-[23px] h-[23px]
          object-cover invert md:invert-0"
        />

        {cartCount > 0 && (
          <div
            className="absolute top-0 right-0 rounded-full  
            h-[20px] w-[20px] 
            bg-secondary-800 font-bold 
            text-[10px] text-white
            text-center leading-[20px]"
          >
            {cartCount > 9 ? '9+' : cartCount}
          </div>
        )}
      </div>
    </div>
  );
}
